<template>
  <div id="common-problem">
    <el-row :gutter="42">
      <el-col v-for="item of list" :key="item.id" :span="12">
        <div class="item">
          <h3 class="problem">{{ item.problem }}</h3>
          <p class="answer" v-html="item.answer"></p>
          <p class="more" @click="handleMoreClick(item)">
            查看更多 <span class="el-icon-arrow-down"></span>
          </p>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="detail.problem"
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleClose"
    >
      <div class="detail">{{ detail.answer }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CommonProblem",
  components: {},
  data() {
    return {
      dialogVisible: false,
      detail: {
        problem: "问题",
        answer: ""
      },
      list: [
        {
          id: 1,
          problem: "1、为什么要选择出国看病？",
          answer:
            "对于一些普通的常见病，海外医疗能带来的是更好的就医体验和更精致周到的细节管理；而对于癌症、心血管、神经系统疾病等重大疾病来说，出国看病意味着更高的生存机会。以癌症治疗为例，国内的整体癌症5年生存只有30.9%，而美国是66.9%；在美国癌症专科排名靠前的医院，如MD安德森癌症中心，大多数癌症的5年生存率达到80%以上。"
        },
        {
          id: 2,
          problem: "2、什么样的患者适合出国看病？",
          answer:
            "1、国内长时间不能确诊\n" +
            "2、国内医院诊断或治疗意见不一\n" +
            "3、疑难杂症，国内缺少治疗经验\n" +
            "4、国内手术风险过高\n" +
            "5、国内缺少治疗药物或设备\n" +
            "6、国内治疗方案会造成不可挽回的损失，如摘除眼球、切除乳房等\n" +
            "7、国内治疗不见好转，甚至病情恶化\n" +
            "8、国内医院束手无策\n" +
            "9、想到国外参加临床试验\n" +
            "10、经济条件好，寻求更充足的医疗资源\n"
        },
        {
          id: 3,
          problem: "3、出国看病需要提供哪些材料",
          answer:
            "1) 病历材料复印件（包括门诊、住院病历，住院期间的化验、检查报告，病理报告，基因检测报告、治疗记录、手术和/或活检记录及出院小结，可凭患者身份证、住院号在医院病案室复印）。\n" +
            "2) 所有影像原片或光盘（包括X线、CT片子、MRI片子、PET-CT片子或光盘、骨扫描等，一般可在医院影像科要求重新出一份）。影像资料若没有国内医院出具的电子版，需要把患者提供的胶片用进口医用扫描仪扫成国际通用的DICOM格式电子版。\n" +
            "3) 病理切片（医院已染色的病理切片；20张以上未染色的病理白片，欲行免疫组化、基因检测等。可凭患者身份证、住院号去医院病理科交押金获得）。\n"
        },
        {
          id: 4,
          problem: "4、出国看病的主要受益点有哪些？",
          answer:
            "1）明确的诊断\n" +
            "诊断错了，治疗的方向很可能跑偏。出国看病的癌症患者中，12%诊断结果与国内不同。在美国、英国等医疗发达国家，病理是癌症诊断的金标准；而国内不管是病理技术的发展，还是病理医生的培养，以及实际肿瘤诊断中对病理的规范使用，都还有所欠缺。\n" +
            "（2）多学科协作诊疗（MDT）\n" +
            "在国内，患者看什么病需要自己去挂号，挂肿瘤科就只能看肿瘤，挂眼科就只能看眼疾，由一个医生做决定。但是，很多疾病是综合交叉的，涉及多个学科。在美国、英国等医疗发达国家，就医先预约一位主诊医生（通常是内科的），主诊医生会根据患者病情，组织一个多学科专家团队，由多学科专家团队来为患者提供诊断，制定治疗方案。这就是多学科协作诊疗模式，又称MDT。国内刚刚开始引进，受限于人均可分配医疗资源的不足，很难广泛普及，但在欧美已经相对成熟地运行了很多年。\n" +
            "（3）个性化的方案\n" +
            "国内由于医疗资源紧缺，单位患者可分配的医疗资源极为有限，疾病治疗大多依托指南照单抓药。然而，每个患者不管是病情还是身体体质，都有其独特性。在美国、英国等医疗发达国家，患者可选择的方案更多，专家团队会为患者制订个性化的治疗方案。77%的出国看病患者治疗方案与国内发生了改变，包括改变治疗方案、给药方式、调整治疗顺序、增减剂量等。\n" +
            "（4）新药\n" +
            "新药、特效药，通常都会率先在欧美上市，滞后一段时间才能进入中国。据国家药品监督管理局2018年统计：过去10年间，美欧日上市的新药有415个，在中国上市的只有76个，占比不到20%。此外，据专业咨询机构IQVIA的统计，2012至2016年，全球共首次上市55种抗癌药，其中美国两年内上市的有46个，中国只有4个。而这些新药，对患者来说是可能是可以救命的。\n" +
            "（5）临床试验\n" +
            "对于已上市的药物和疗法不能控制病情的癌症患者来说，参加临床试验可能是最后的希望。但截至2018年9月，全球共有近30万项临床试验登记注册，其中有40%在美国进行，在中国开展的仅占7%。而且，更新、更前沿的临床试验通常都在美国。在美国癌症专科排名第一的MD安德森癌症中心，每天有数百项临床试验在同时进行，患者只要符合条件，就可以申请入组。\n" +
            "（6）设备、环境、人文关怀等其他\n"
        },
        {
          id: 5,
          problem: "5、出国看病一定能把病看好吗？",
          answer:
            "医疗具有很大的不确定性，而且出国看病的70%都是癌症患者，世界上没有任何一家医院、任何一位医生可以百分百治好癌症。如果有人这么说，那一定是骗人的。对于早期癌症，尽早出国看病可以获得更高的根治可能。如果是中晚期癌症，有的患者可能长期完全缓解；有的患者可能延长生命等待新治疗技术的出现，同时获得更好的生存质量；也有的患者可能无功而返，甚至在国外去世。"
        },
        {
          id: 6,
          problem: "6、远程咨询是否可以替代出国看病？",
          answer:
            "目前在实际运用中，远程咨询还存在很大的局限性。\n" +
            "首先，医生无法进一步检查评估，对于患者的诊疗建议都是基于国内的影像和病历资料。和医生当面见到患者、观察患者、为患者安排相应需要的检查，所能作出的判断和建议是有很大区别的。而且国内外对影像的要求标准也有所不同。\n" +
            "其次，如果是制定方案，远程咨询在有限的提问次数或沟通时间内，国外医生有可能无法给出一个确切的治疗方案。尤其是癌症，国外通常需要多学科讨论，讲究的是个性化治疗，患者的病理类型、基因突变情况、身体状况以及是否还伴有其他疾病等，都会影响方案的制定。仅通过远程会诊，可能无法满足制定方案的要求。\n" +
            "此外，在落地实施方面也有受限。美国在新药和新技术的研发方面可以说领跑全球，其中部分在国内还没有上市，又或者一些治疗方案国内的医生并不熟悉。这样一来，远程咨询即便给出相对具体的方案，国内可能也无法实施。\n" +
            "一般来说，如果患者病情比较严重，不太适合长途飞行，可以通过远程咨询获取国外专家的治疗建议。越是严重的疾病，下一步的治疗就越是关键，远程咨询意见可以为患者和国内主治医生提供有价值的参考，或者评估患者是否适合出国看病。\n"
        },
        {
          id: 7,
          problem: "7、出国看病要花多少钱？",
          answer:
            "出国看病一般分为两个阶段。\n" +
            "第一个阶段是病情评估阶段，患者到国外医院见到主诊医生，接受面诊和相关检查后，由多学科团队评估患者病情，给出明确的诊断和个性化治疗方案。这一阶段大概需要在国外停留1-2周，如果是美国，大概需要花费2-5万美元；如果是英国，大概需要花费1-2万英镑；如果是日本，大概需要花费3-5万人民币。\n" +
            "第二个阶段是方案实施阶段，以癌症治疗为例，患者一般需要在国外停留3-6个月的时间（具体停留时间取决于国外治疗方案）。算上第一阶段的花费，如果是美国，患者大概需要花费20-40万美元；如果是英国，大概需要花费5-10万英镑；如果是日本，大概需要花费50-100万人民币。部分患者会低于这个数，也有部分患者会高于这个花费，具体依据实施的治疗方案而定。\n" +
            "对患者而言，第一个阶段——病情评估阶段非常有价值，因为绝大多数误诊、误治、落后医疗，都源于诊断和方案制定的过程。诊断对了，方案对了，如果国内有实施方案的条件，患者也可以选择回国治疗。\n"
        },
        {
          id: 8,
          problem: "8、出国看病办理流程？",
          answer:
            "1) 医学咨询（客户预留信息后一个工作日内医学顾问首次联系，进行咨询）\n" +
            "2) 提供病历材料（前期沟通后客户决定采纳服务，提供相应材料）\n" +
            "3) 签约付款（客户署合同并支付服务费首款）\n" +
            "4) 推荐医院（病历摘要撰写及翻译；医院医生筛选推荐；签证材料辅导）\n" +
            "5) 发起预约（根据客户选择进行预约）\n" +
            "6) 支付医院预估费用（完成预约，指导客户向医院支付预估费用）\n" +
            "7) 签证辅助（协助客户获取相应国家医疗签证）\n" +
            "8) 行前指导（预订机票及住宿，行前指导，安排国外负责人）\n" +
            "9) 出国就医（当地提供用车、翻译陪同等各项医疗周边服务）\n" +
            "10) 回国（诊疗结束回国后，将客户国外就医资料翻译成中文）\n"
        },
        {
          id: 9,
          problem: "9、办理出国看病需要多长时间？",
          answer:
            "由于和美国、英国、日本排名靠前的医院签署有正式的官方合作转诊协议，可以在7个工作日内快速完成医院预约。如果患者有签证，从患者签约起，一般2周左右可以见到国外医生，快则1周内即可。"
        },
        {
          id: 10,
          problem: "10、我们提供哪些服务？",
          answer:
            "1) 出国前：基础医学咨询、国外医院及专家推荐、病历资料整理及翻译、国外医院预约、病理和影像资料邮寄、医疗签证辅助办理、国外住宿安排、机票预订、行前指导、病历资料更新……\n" +
            "2) 出国后：出国陪同、海外接送机、海外公寓住宿、海外用车、就医翻译陪同、海外生活照顾、海外紧急事件处理……\n" +
            "3) 回国后：国外就医资料翻译成中文、医院账单处理指导、国外专家随访、再次预约国外医院……\n"
        }
      ]
    };
  },
  mounted() {},
  methods: {
    handleMoreClick(item) {
      this.dialogVisible = true;
      this.detail = item;
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
#common-problem {
  overflow: hidden;
  .item {
    height: 152px;
    overflow: hidden;
    padding: 22px;
    margin: 0 5px 53px 5px;
    box-shadow: 0 7px 15px 1px rgba(213, 213, 213, 0.19);
    /*background: #efefef;*/
    .problem {
      color: #e6a53d;
      font-size: 20px;
      margin-bottom: 20px;
    }
    .answer {
      color: #b9b9b9;
      font-size: 18px;
      line-height: 24px;
      height: 70px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
    .more {
      cursor: pointer;
      margin-top: 22px;
      color: #b8b8b8;
      font-size: 18px;
      text-align: center;
    }
  }
  .detail {
    color: #b8b8b8;
    font-size: 16px;
    line-height: 24px;
    text-indent: 2em;
  }
}
</style>
